import { Injectable } from '@angular/core';

import { HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { AppConfig } from '../app.config';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';
import { catchError, map } from "rxjs/operators";


// Add this for error feedback

@Injectable({
  providedIn: 'root',
})
export class HelpersService {
  private authData: string = 'AuthData';
  private authDataNew: string = 'authDataNew';
  private profileData: string = 'ProfileData';
  private partnerData: string = 'PartnerData';
  private countryData: string = 'CountryData';
  private productData: string = 'ProductData';
  private profileInsuranceRoles: string = 'ProfileInsuranceRoles';
  private clubData: string = 'ClubData';
  private routeData: string = 'routeData';
  private printerType: string = 'PrinterType';
  private smsLowCreditDisplayed: string = 'SMSLowCreditDisplayed';
  private paymentStatus: string = 'PaymentStatus';
  private checklistCount: string = 'ChecklistCount';
  private tour: string = 'Tour';

  private products: any = [];

  private headers: any;
  private httpHeaders: HttpHeaders;
  private storageSub = new BehaviorSubject<any>({});
  private requestOptions: any;

  constructor(
    public http: HttpClient,
    private router: Router,
    public appConfig: AppConfig,
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) { }

  public getAuthData() {
    let loggedInUser: any;
    if (localStorage.getItem(this.authData)) {
      loggedInUser = JSON.parse(
        window.atob(localStorage.getItem(this.authData)),
      );
    }
    return loggedInUser;
  }

  public getAuthDataNew() {
    let loggedInUser: any;
    if (localStorage.getItem(this.authDataNew)) {
      loggedInUser = JSON.parse(
        window.atob(localStorage.getItem(this.authDataNew)),
      );
    }
    return loggedInUser;
  }

  public getNewApiHeaders() {
    this.headers = {
      'Content-Type': 'application/json',
      'PartnerID': this.getPartnerId() ? this.getPartnerId() : '',
      Accept: 'application/json',
      Authorization: `Bearer ${this.getAuthDataNew() ? this.getAuthDataNew().token : ''
        }`,
    };
    return { headers: this.headers };
  }



  public saveAuthData(data): void {
    localStorage.setItem(
      this.authData,
      window.btoa(
        JSON.stringify({ username: data.userName, token: data.legacyToken }),
      ),
    );
    //console.log(localStorage.getItem(this.authData));
  }

  public saveAuthDataNew(data): void {
    localStorage.setItem(
      this.authDataNew,
      window.btoa(
        JSON.stringify({ username: data.userName, token: data.token }),
      ),
    );
  }

  public getSelectedClub() {
    let clubData: any = {};
    if (localStorage.getItem(this.clubData)) {
      clubData = JSON.parse(
        decodeURIComponent(
          escape(window.atob(localStorage.getItem(this.clubData))),
        ),
      );
    }
    return clubData;
  }

  public setService(service) {
    localStorage.setItem(
      'serviceData',
      window.btoa(unescape(encodeURIComponent(JSON.stringify({ service })))),
    );
  }

  public getService() {
    return JSON.parse(window.atob(localStorage.getItem('serviceData'))).service;
  }

  public setChecklistCount(value) {
    localStorage.setItem(
      this.checklistCount,
      window.btoa(
        unescape(encodeURIComponent(JSON.stringify({ checklistCount: value }))),
      ),
    );
  }

  public getChecklistCount() {
    var count = null;
    try {
      count = JSON.parse(
        window.atob(localStorage.getItem(this.checklistCount)),
      ).checklistCount;
    } catch (err) { }
    return count;
  }

  public setActiveProduct(value) {
    //Passing null/undefined means "clear it". The old `value || 'WORKSHOP'` silently
    //pinned the vertical to Workshop instead, so callers that meant to reset it were
    //really choosing Workshop for the user.
    if (value === null || value === undefined) {
      localStorage.removeItem('activeProduct');
    } else {
      localStorage.setItem('activeProduct', value);
    }
  }

  //Everything cached here is scoped to ONE store. Switching stores must drop all of
  //it, or the vertical/subscription decisions for the new store get made from the old
  //store's data. PartnerID lives on the profile blob and is deliberately NOT cleared.
  public clearTenantScopedCache(): void {
    localStorage.removeItem('activeProduct');
    localStorage.removeItem('lastURL');
    localStorage.removeItem(this.paymentStatus);
    this.saveProductData([]);
    //{} rather than removeItem: getActiveProduct() and portal's setActiveProduct()
    //both dereference .SubscribedProducts unguarded, and {} keeps their fallbacks working.
    this.savePartnerData({});
  }

  //Decides which vertical (WORKSHOP or RENTALS) the user should be in for the store
  //currently cached in PartnerData. This is the single source of truth - portal's
  //setActiveProduct() used to re-derive it with its own copy of the status filter.
  //
  //Two DIFFERENT questions have to be kept apart:
  //  usable - a subscription row exists AND its status is workable ([1,3,4,20,50,51],
  //           which excludes 2 TrialExpired and 21 Cancelled)
  //  owned  - a subscription row exists at ALL, whatever its status
  //Ownership matters because GetPaymentStatusV2 fabricates statusID 2 when the row is
  //missing, so "never had this product" and "trial expired" look identical in the API
  //response. Only SubscribedProducts can tell them apart.
  public resolveActiveProduct(): string {
    const partner = this.getPartnerData() || {};
    const rows = ((partner.SubscribedProducts) || [])
      .map((r) => {
        return {
          type: (r.ProductType || r.productType || '').toUpperCase(),
          statusID: r.StatusID,
        };
      })
      .filter((r) => {
        return r.type === 'WORKSHOP' || r.type === 'RENTALS';
      });

    const usable: string[] = rows
      .filter((r) => { return [1, 3, 4, 20, 50, 51].indexOf(r.statusID) > -1; })
      .map((r) => { return r.type; });
    const owned: string[] = rows.map((r) => { return r.type; });

    const stored = localStorage.getItem('activeProduct');
    const urlIsRentals =
      this.router.url.toLocaleLowerCase().indexOf('/rentals/') > -1;
    //What the user last chose, or what the URL they're on implies. May be null,
    //and may name a product this store doesn't have.
    const preferred = urlIsRentals ? 'RENTALS' : (stored || null);
    const isDemo = partner.StatusID === 51;

    //Demo accounts with nothing subscribed yet: default to Workshop.
    if (isDemo && !usable.length) {
      return 'WORKSHOP';
    }

    //Honour what the user last chose (or the URL they're on) for any product the store
    //OWNS - including a lapsed one, so they can reach its manage-subscription page and
    //resubscribe. Restricting this to `usable` snapped them straight back out of a
    //lapsed vertical, leaving no route to fix it. Products the store has no row for
    //are still ignored, so a stale preference can never resurrect a foreign vertical.
    if (preferred && owned.indexOf(preferred) > -1) {
      return preferred;
    }

    //Both usable: Workshop wins, matching the behaviour before this refactor.
    if (usable.indexOf('WORKSHOP') > -1) {
      return 'WORKSHOP';
    }

    //Exactly one usable product: that one. This is the rentals-only store.
    if (usable.length) {
      return usable[0];
    }

    //Nothing usable, but the store DOES own something - every product it has is
    //expired or cancelled. Stay on the owned vertical so routeToPricing sends them
    //to THAT product's manage-subscription screen and they can resubscribe.
    //Ordered explicitly rather than taking owned[0], which is just SQL row order.
    if (owned.length) {
      if (preferred && owned.indexOf(preferred) > -1) {
        return preferred;
      }
      return owned.indexOf('WORKSHOP') > -1 ? 'WORKSHOP' : 'RENTALS';
    }

    //Owns neither product.
    return 'WORKSHOP';
  }

  public getActiveProduct() {
    return this.resolveActiveProduct();
  }

  public setLastURL(value) {
    localStorage.setItem('lastURL', value);
  }

  public getLastURL() {
    return localStorage.getItem('lastURL');
  }

  public setSMSMessageDisplayed() {
    localStorage.setItem(this.smsLowCreditDisplayed, 'true');
  }

  public getSMSMessageDisplayed() {
    return localStorage.getItem(this.smsLowCreditDisplayed) === 'true';
  }

  public clearSMSMessageDisplayed() {
    localStorage.setItem(this.smsLowCreditDisplayed, null);
  }

  public setSelectedClub(club) {
    //const savedClubObj = this.getSelectedClub();
    club.Members = []; //May make the Localstorage size large where large member lists occur
    localStorage.setItem(
      this.clubData,
      window.btoa(unescape(encodeURIComponent(JSON.stringify({ ...club })))),
    );
  }

  public setPrinterType(printer) {
    localStorage.setItem(this.printerType, printer);
  }

  public getPrinterType() {
    return localStorage.getItem(this.printerType);
  }

  public convertDate(date: Date) {
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  }

  public convertDateAndTime(date: Date) {
    return `${date.getFullYear()}-${date.getMonth() + 1
      }-${date.getDay()}T${date.getDate()}:${date.getMinutes()}:00`;
  }

  public getProfileData() {
    let profileData: any;
    if (localStorage.getItem(this.profileData)) {
      profileData = JSON.parse(
        window.atob(localStorage.getItem(this.profileData)),
      );
    }
    return profileData ? profileData.data : null;
  }

  public getProfileInsuranceRoles() {
    let profileData: any;
    if (localStorage.getItem(this.profileInsuranceRoles)) {
      profileData = JSON.parse(
        window.atob(localStorage.getItem(this.profileInsuranceRoles)),
      );
    }
    return profileData ? profileData.data : null;
  }

  getDistanceMetric() {
    return this.getProfileData().UnitsOfMeasureID === 1 ? 'km' : 'mi';
  }

  public getPartnerId() {
    let partnerId: any;
    if (localStorage.getItem(this.profileData)) {
      partnerId = JSON.parse(
        window.atob(localStorage.getItem(this.profileData)),
      ).data.PartnerID;
    }
    return partnerId;
  }

  public getUserId() {
    let userId: any;
    if (localStorage.getItem(this.profileData)) {
      userId = JSON.parse(window.atob(localStorage.getItem(this.profileData)))
        .data.ID;
    }
    return userId;
  }

  public saveProfileData(data): void {
    localStorage.setItem(
      this.profileData,
      window.btoa(JSON.stringify({ data })),
    );
  }

  public saveProfileInsuranceRoles(data): void {
    localStorage.setItem(
      this.profileInsuranceRoles,
      window.btoa(JSON.stringify({ data })),
    );
  }

  /**
   * Whether the tax row should be displayed. Always true when tax is non-zero;
   * when tax is zero it follows the partner's ShowZeroTaxAmounts setting (default ON).
   */
  public showTaxRow(totalTax: any, partner?: any): boolean {
    const p = partner || this.getPartnerData() || {};
    // Shop-side partner data is PascalCase; customer-portal API payloads are camelCase.
    if ((p.ShowZeroTaxAmounts ?? p.showZeroTaxAmounts) !== false) return true;
    return Math.round((Number(totalTax) || 0) * 100) !== 0;
  }

  public getPartnerData() {
    let partnerData: any;
    if (localStorage.getItem(this.partnerData)) {
      partnerData = JSON.parse(
        decodeURIComponent(
          escape(window.atob(localStorage.getItem(this.partnerData))),
        ),
      ).data;
    }
    return partnerData;
  }

  /*public saveRouteData(route) {
                                localStorage.setItem(
                                  this.routeData,
                                  window.btoa(JSON.stringify({ route }))
                                );
                              }

                              public getRouteData() {
                                let routeData: any;
                                if (localStorage.getItem(this.routeData)) {
                                  routeData = JSON.parse(
                                    decodeURIComponent(
                                      escape(window.atob(localStorage.getItem(this.routeData)))
                                    )
                                  ).route;
                                }
                                return routeData;
                              }*/

  public savePartnerData(data): void {
    localStorage.setItem(
      this.partnerData,
      window.btoa(unescape(encodeURIComponent(JSON.stringify({ data })))),
    );
  }

  public getCountryData() {
    let countryData: any;
    if (localStorage.getItem(this.countryData)) {
      countryData = JSON.parse(
        decodeURIComponent(
          escape(window.atob(localStorage.getItem(this.countryData))),
        ),
      ).data;
    } else {
      countryData = {
        DatePickerFormat: 'yy-mm-dd',
        AngularDateFormat: 'yyyy-MM-dd',
        MomentDateFormat: 'YYYY-MM-DD',
      };
    }
    return countryData;
  }

  public saveCountryData(data): void {
    localStorage.setItem(
      this.countryData,
      window.btoa(unescape(encodeURIComponent(JSON.stringify({ data })))),
    );
  }

  public getProductData() {
    let productData: any;
    if (navigator.userAgent.indexOf('Safari') > -1) {
      productData = this.products;
    } else {
      if (localStorage.getItem(this.productData)) {
        productData = JSON.parse(
          decodeURIComponent(
            escape(window.atob(localStorage.getItem(this.productData))),
          ),
        ).data;
        if (!productData || productData.length === 0) {
          productData =
            this.products && this.products.length > 0
              ? this.products
              : productData;
        }
      } else {
        productData = this.products;
      }
    }
    return productData;
  }

  public saveProductData(data): void {
    this.products = [];
    try {
      if (navigator.userAgent.indexOf('Safari') > -1) {
        localStorage.removeItem(this.productData);
        this.products = data;
      } else {
        localStorage.setItem(
          this.productData,
          window.btoa(unescape(encodeURIComponent(JSON.stringify({ data })))),
        );
      }
    } catch (e) {
      localStorage.removeItem(this.productData);
      this.products = data;
    }
  }

  public getAuthenticatedRequestOptions(useOld = true) {
    if (useOld) {
      let accessToken: any;
      if (localStorage.getItem(this.authData)) {
        accessToken = JSON.parse(
          window.atob(localStorage.getItem(this.authData)),
        ).token;
      } else {
        this.removeTokenAndLogout();
      }
      this.headers = new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `bearer ${accessToken}`,
      });

      this.requestOptions = { headers: this.headers };
      return this.requestOptions;
    } else {
      let accessToken: any;
      if (localStorage.getItem(this.authData)) {
        accessToken = JSON.parse(
          window.atob(localStorage.getItem(this.authData)),
        ).token;
      } else {
        this.removeTokenAndLogout();
      }
      this.headers = new Headers({
        // "Content-Type": "application/json",
        // Accept: "application/json",
        'x-functions-key': this.appConfig.getOldProdKey(),
        'user-id': this.getUserId(),
      });

      this.requestOptions = { headers: this.headers };
      return this.requestOptions;
    }
  }

  public clearCache(): void {
    localStorage.removeItem('activeProduct');
    localStorage.removeItem('lastURL');
    localStorage.removeItem(this.authData);
    localStorage.removeItem(this.authDataNew);
    localStorage.removeItem(this.productData);
    localStorage.removeItem(this.profileData);
    localStorage.removeItem(this.clubData);
    localStorage.removeItem(this.partnerData);
    localStorage.removeItem(this.paymentStatus);
    localStorage.removeItem('XeroPartnerID');
  }

  public removeTokenAndLogout(): void {
    this.clearCache();
    this.storageSub.next({});
    if (this.router.url.indexOf('returnUrl') === -1) {
      this.router.navigate(['/'], {
        queryParams: {
          returnUrl: this.router.url,
        },
      });
    }
  }

  public savePaymentStatus(data) {
    localStorage.setItem(
      this.paymentStatus,
      window.btoa(unescape(encodeURIComponent(JSON.stringify({ data })))),
    );
  }

  public getPaymentStatus() {
    let data: any;
    if (localStorage.getItem(this.paymentStatus)) {
      data = JSON.parse(
        decodeURIComponent(
          escape(window.atob(localStorage.getItem(this.paymentStatus))),
        ),
      ).data;
    }
    return data;
  }

  public isSubscriptionActive() {
    let data: any;
    if (localStorage.getItem(this.paymentStatus)) {
      data = JSON.parse(
        decodeURIComponent(
          escape(window.atob(localStorage.getItem(this.paymentStatus))),
        ),
      ).data;
    }
    return data.statusID !== 2 && data.statusID !== 21;
  }

  public getAuthenticatedRequestOptionsNew() {
    let accessToken: any;
    if (localStorage.getItem(this.authDataNew)) {
      accessToken = JSON.parse(
        window.atob(localStorage.getItem(this.authDataNew)),
      ).token;
    } else {
      this.removeTokenNew();
    }
    this.headers = new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `bearer ${accessToken}`,
    });

    this.requestOptions = { headers: this.headers };
    return this.requestOptions;
  }

  public removeTokenNew(): void {
    localStorage.removeItem(this.authDataNew);
    localStorage.removeItem(this.profileData);
    this.storageSub.next({});
    if (this.router.url.indexOf('returnUrl') === -1) {
      this.router.navigate(['/'], {
        queryParams: {
          returnUrl: this.router.url,
        },
      });
    }
  }

  showTour(screen) {
    var showTour = this.getPartnerData().ShowTour;
    var data = JSON.parse(localStorage.getItem(this.tour));
    return showTour && (data === null || !data[screen]);
  }

  tourComplete(screen) {
    var data = JSON.parse(localStorage.getItem(this.tour)) || {};
    data[screen] = true;

    localStorage.setItem(this.tour, JSON.stringify(data));
    console.log(data);
    if (
      data['Calendar'] &&
      data['Cyclist'] &&
      data['ServiceTypes'] &&
      data['JobCard'] &&
      data['Quote']
    ) {
      console.log(data);
      let requestOptions = this.getAuthenticatedRequestOptions();
      return this.http
        .get(
          this.appConfig.getEnvironment() +
          `/api/Partner/${this.getPartnerData().ID}/TourComplete`,
          requestOptions,
        )
        .subscribe(() => { });
    }
  }

  //POS API
  public getPOSApiHeaders(key, partnerid = "", identifier = "") {
    this.headers = new Headers({
      'Content-Type': 'application/json',
      'PartnerID': partnerid ? partnerid : this.getPartnerId(),
      'PartnerKey': identifier,
      'x-functions-key': key,
      Accept: 'application/json',
      Authorization: `Bearer ${this.getAuthDataNew() ? this.getAuthDataNew().token : ''}`,
    });
    return { headers: this.headers };
  }

  getCountryFromIP() {
    return this.http.get('https://ipapi.co/json').pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      }),
    );
  }

  public isAdminUser() {
    const profile = this.getProfileData();
    var isAdmin = profile?.UserRoles?.filter(role => role.PartnerID === this.getPartnerId() && role.RoleID === 2).length > 0;
    return isAdmin;
  }
  public isWorkshopManagerUser() {
    const profile = this.getProfileData();
    var isWorkshopManager = profile?.UserRoles?.filter(role => role.PartnerID === this.getPartnerId() && role.RoleID === 3).length > 0;
    return isWorkshopManager;
  }

  public isJobcardLocked(jobcard: any): boolean {
    const partnerData = this.getPartnerData();
    if (partnerData.LockJobCardOnCollection && jobcard.statusID == 50) return true;
        return false;
  }
}
